import type { ModelAsset } from '@/content/schema';
import { useGLTF } from '@react-three/drei';

export const MODELS_BASE = '/models/';

export function preloadModel(model: ModelAsset) {
  useGLTF.preload(MODELS_BASE + model.glb, true, true);
}
